import { render, staticRenderFns } from "./BotWlcmHomeCampaignForm.vue?vue&type=template&id=7218123a"
import script from "./BotWlcmHomeCampaignForm.vue?vue&type=script&lang=ts"
export * from "./BotWlcmHomeCampaignForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports